import {createSlice} from '@reduxjs/toolkit';

import {trackingBuilder} from './reducer';

const initialState: any = {
  loading: 0,
  error: '',
  tracking: {},
  trackings: {tickets: [], total_items: 0}
};

export const trackingSlicer = createSlice({
  name: 'tracking',
  initialState,
  reducers: {
    emptyTrackings: (state: any) => {
      state.trackings = {tickets: [], total_items: 0};
    }
  },
  extraReducers: trackingBuilder
});

export const {emptyTrackings} = trackingSlicer.actions;
export default trackingSlicer.reducer;
